import { IonButton, IonCol, IonRow, IonSearchbar } from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { utilService } from "../../../../services";
import { NurseContext } from "../../NurseManagement";
import { NurseManagementService } from "../../NurseManagementService";
import {
  AddPhoneNumberResponse,
  GetPhoneListResponse,
  PhonesData,
} from "../../NurseMgmtDataModels";
import AddPhoneNumberModal from "../AddPhoneNumberModal/AddPhoneNumberModal";
import Loader from "../../../../components/Shared/Loader/Loader";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";

interface SelectPhoneProps {
  resetData: boolean;
  setUpdateData: Function;
  setActiveTabInMobile: Function;
}

const SelectPhone: React.FunctionComponent<SelectPhoneProps> = (props) => {
  const Toast = useToast();
  const { t } = useTranslation("nursemanagement");
  
  const nurseContextData = useContext(NurseContext);

  const [phonesList, setPhonesList]: [[], Function] = useState([]);
  const [searchedPhone, setSearchedPhone] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);
  const [disableSelectPhone, setDisableSelectPhone] = useState(false);

  useEffect(() => {
    props.resetData && setPhonesList([]);
    !props.resetData
      ? setDisableSelectPhone(false)
      : setDisableSelectPhone(true);
  }, [props.resetData]);

  useEffect(() => {
    nurseContextData.selectedUnit && getPhoneList();
  }, [nurseContextData.selectedUnit]);


  useEffect(()=>{
    if(nurseContextData.selectedNurseGuid){
      const selectedPhone:any = phonesList.find((phone:any)=>phone.assigned_status === nurseContextData.selectedNurseGuid)
      if(selectedPhone?.assigned_status){
        const phoneNumberObj = {
          number: selectedPhone?.assigned_status ? selectedPhone?.number : "",
          id: selectedPhone?.id,
        };
        props.setUpdateData(
          nurseContextData.selectedUnit,
          nurseContextData.selectedNurseId,
          phoneNumberObj,
          {},
          nurseContextData.selectedNurseGuid,
          "phone"
        );
      }
    }
  },[nurseContextData.selectedNurseGuid])

  const getPhoneList = async (searchedPhone?: string) => {
    setShowLoader(true);
    const reqParam: { unit_id: string; reg_code: string; name?: string } = {
      unit_id: nurseContextData.selectedUnit,
      reg_code: utilService.getNetwork(),
    };
    if (searchedPhone) {
      reqParam.name = formatNumber(searchedPhone);
    }
    const phonesData: GetPhoneListResponse =
      await NurseManagementService.getPhones(reqParam);
    if (phonesData.isSuccess) {
      setPhonesList(
        phonesData.result.map((phone) => {
          return { ...phone, showPhoneUpdate: false };
        })
      );
    } else {
      setPhonesList([]);
      Toast.error(phonesData.message);
    }
    setShowLoader(false);
  };

  const handleSearch = (event: any) => {
    // event.persist();
    setSearchedPhone(event.target.value);
    getPhoneList(event.target.value);
  };

  const handleAddPhone = () => {
    setShowModal(true);
  };

  const formatInput = (value: string, previousValue: string) => {
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    } else {
      if (cvLength === 0) return "";
      return value;
    }
  };

  const handleEditClick = (phoneObj: any, source: string, updatedVal = "") => {
    const filteredObj: any = phonesList.filter((phone: any) => {
      return phone.id === phoneObj.id;
    });
    if (source === "edit") {
      filteredObj[0].showPhoneUpdate = true;
    } else if (source === "update") {
      filteredObj[0].number = formatInput(updatedVal, filteredObj[0].number);
    }
    setPhonesList([...phonesList]);
  };

  const handleUpdateClick = async (phoneObj: any) => {
    if (phoneObj.number.length !== 14) {
Toast.error(t("phoneValidation"));
      return;
    }
    const updatePhoneRes: AddPhoneNumberResponse =
      await NurseManagementService.addPhone({
        number: phoneObj.number,
        reg_code: utilService.getNetwork(),
        id: phoneObj.id,
      });
    if (updatePhoneRes.isSuccess) {
      getPhoneList();
    } else {
      Toast.error(updatePhoneRes.message);
    }
  };

  const assignUnAssignPhone = (phone: PhonesData) => {
    if (phone.assigned_status !== nurseContextData.selectedNurseGuid) {
      phonesList.map((phone: PhonesData) => {
        return (phone.assigned_status =
          phone.assigned_status === nurseContextData.selectedNurseGuid
            ? ""
            : phone.assigned_status);
      });
    }
    phone.assigned_status = phone.assigned_status
      ? ""
      : nurseContextData.selectedNurseGuid;
    setPhonesList([...phonesList]);
    const phoneNumberObj = {
      number: phone.assigned_status ? phone.number : "",
      id: phone.id,
    };
    props.setUpdateData(
      nurseContextData.selectedUnit,
      nurseContextData.selectedNurseId,
      phoneNumberObj,
      {},
      nurseContextData.selectedNurseGuid,
      "phone"
    );
  };

  const formatNumber = (searchedPhone: any) => {
    const tel = removeInvalidCharacters(searchedPhone);
    let city;
    let pnumber;
    let value: any = tel[0] === "+" ? tel.toString().slice(1) : tel;
    if (value && value.length && value.length > 3) {
      city = value.slice(0, 3);
      pnumber = value.slice(3);

      pnumber =
        pnumber.length > 3
          ? pnumber.slice(0, 3) + "-" + pnumber.slice(3)
          : pnumber;

      value = (" (" + city + ") " + pnumber).trim();
    }
    return value;
  };
  const removeInvalidCharacters = (searchedPhone: any) => {
    let newValue = searchedPhone;
    if (newValue && newValue.match(/^[^- ()0-9]+$/)) {
      newValue = newValue
        ? newValue.toString().replace(/^[^- ()0-9]+$/, "")
        : "";
    }
    return newValue;
  };

  return (
    <div className="card-container select-phone-container w-100">
      <h5 className="header-text">{t("selectPhone")}</h5>
      {
        <IonRow className="select-phone-div">
          <IonCol col-md="12" col-lg="6" size="6">
            <IonSearchbar
              debounce={1000}
              value={searchedPhone}
              onIonChange={(e) => handleSearch(e)}
              disabled={disableSelectPhone}
            ></IonSearchbar>
          </IonCol>
          <IonCol col-md="12" col-lg="6" size="6">
            <IonButton
              className="w-100 secondary-transparent-btn add-phone-btn"
              onClick={handleAddPhone}
              disabled={disableSelectPhone}
            >
 + {t("addPhone")}
             </IonButton>
          </IonCol>
          {showModal && (
            <AddPhoneNumberModal
              showModal={showModal}
              handleClose={setShowModal}
              getPhoneList={getPhoneList}
            />
          )}
        </IonRow>
      }
      {showLoader && (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}
      {phonesList.length ? (
        <div className="card-content">
          <IonRow>
            <IonCol size="12">
              <ul className="ul-list">
                {phonesList.map((phone: any) => {
                  return (
                    <li key={phone.id}>
                      {!phone.showPhoneUpdate ? (
                        <div
                          className={`list-val-container d-flex align-items-center clickable ${
                            nurseContextData.selectedNurseGuid &&
                            phone.assigned_status ===
                              nurseContextData.selectedNurseGuid
                              ? "selected"
                              : ""
                          }`}
                          onClick={() =>
                            nurseContextData.selectedNurseId &&
                            assignUnAssignPhone(phone)
                          }
                        >
                          <span className="icon-contact img-icon phone d-flex align-items-center"></span>
                          <span className="list-val">{phone.number}</span>
                        </div>
                      ) : (
                        <div className="list-val-container d-flex align-items-center">
                          <input
                            type="text"
                            className="w-100"
                            value={phone.number}
                            onChange={(e) =>
                              handleEditClick(phone, "update", e.target.value)
                            }
                          />
                        </div>
                      )}
                      {phone.showPhoneUpdate ? (
                        <IonButton
                          className="primary-transparent-btn"
                          onClick={() => handleUpdateClick(phone)}
                        >
                          <div><div>{t("update")}</div>
</div>
                        </IonButton>
                      ) : (
                        <IonButton
                          className="button primary-transparent-btn button-xsm btn-curved"
                          onClick={() => handleEditClick(phone, "edit")}
                        >
<div>{t("edit")}</div>
                        </IonButton>
                      )}
                    </li>
                  );
                })}
              </ul>
            </IonCol>
          </IonRow>
        </div>
      ) : (
        <div className="card-content d-flex justify-content-center align-items-center">
          <div className="no-content-msg">
            <div className="no-data-icon icon-no_phone mb-3"></div>
<div>{t("noPhones")}</div>
          </div>
        </div>
      )}
      <div className="mobile-nav-buttons">
        <IonButton
          className="button tertiary-btn btn-curved"
          onClick={() => props.setActiveTabInMobile(1)}
        >
            {t("prev")}

        </IonButton>
        <IonButton
          className="button tertiary-btn btn-curved"
          onClick={() => props.setActiveTabInMobile(3)}
        >
            {t("next")}

        </IonButton>
      </div>
    </div>
  );
};

export default SelectPhone;
